import type { TrackingState } from '~/composables/usePropertyViewTracking/types';

import { defineStore, skipHydrate } from 'pinia';

export const usePropertyViewTrackingStore = defineStore(
	'propertyViewTracking',
	() => {
		const state = shallowRef<TrackingState | null>(null);
		const updateIntervalId = shallowRef<ReturnType<typeof setInterval> | null>(
			null
		);
		const isSyncingOffline = shallowRef(false);

		function setState(newState: TrackingState | null) {
			state.value = newState;
		}

		function setViewId(viewId: string) {
			if (state.value) {
				state.value = { ...state.value, viewId };
			}
		}

		function setCurrentTime(time: number) {
			if (state.value) {
				state.value = { ...state.value, currentTime: time };
			}
		}

		function setVideoDuration(videoDuration: number) {
			if (state.value) {
				state.value = { ...state.value, videoDuration };
			}
		}

		function setIsEnded(isEnded: boolean) {
			if (state.value) {
				state.value = { ...state.value, isEnded };
			}
		}

		function setHasClicked() {
			if (state.value) {
				state.value = { ...state.value, hasClicked: true };
			}
		}

		function setHasFavorited() {
			if (state.value) {
				state.value = { ...state.value, hasFavorited: true };
			}
		}

		function setHasContacted() {
			if (state.value) {
				state.value = { ...state.value, hasContacted: true };
			}
		}

		function setUpdateIntervalId(id: ReturnType<typeof setInterval> | null) {
			if (updateIntervalId.value) {
				clearInterval(updateIntervalId.value);
			}
			updateIntervalId.value = id;
		}

		function clearUpdateInterval() {
			if (updateIntervalId.value) {
				clearInterval(updateIntervalId.value);
				updateIntervalId.value = null;
			}
		}

		function setIsSyncingOffline(value: boolean) {
			isSyncingOffline.value = value;
		}

		return {
			state: skipHydrate(state),
			updateIntervalId: skipHydrate(updateIntervalId),
			isSyncingOffline: skipHydrate(isSyncingOffline),
			setState,
			setViewId,
			setCurrentTime,
			setVideoDuration,
			setIsEnded,
			setHasClicked,
			setHasFavorited,
			setHasContacted,
			setUpdateIntervalId,
			clearUpdateInterval,
			setIsSyncingOffline
		};
	}
);
